/* Lovable product gallery -- mouse drag-to-slide for the DESKTOP transform slider.
   Desktop gallery moves via rail.style.transform = translateX(-i*100%), driven by
   [data-gallery-prev/next] and [data-thumb] (see lovable-product.js `go`). We drag
   the transform 1:1 with the mouse, then hand off to the gallery's own logic by
   clicking the target thumbnail so index/arrows/thumbs stay in sync.
   Mobile (<=749px) turns the rail into a native scroll container, so there we do
   nothing and let the native swipe work. */
(function () {
  var MQ_MOBILE = "(max-width: 749px)";

  function init(rail) {
    if (!rail || rail.__lvpDrag) return;
    rail.__lvpDrag = true;

    var gallery = rail.closest(".lvp-gallery") || rail.parentNode;

    rail.style.cursor = "grab";
    rail.addEventListener("dragstart", function (e) { e.preventDefault(); }); // no ghost image

    function isMobile() { return window.matchMedia(MQ_MOBILE).matches; }
    function slideCount() { return rail.children.length; }
    function slideWidth() {
      var s = rail.querySelector(".lvp-gallery__slide");
      return s ? s.getBoundingClientRect().width : rail.getBoundingClientRect().width;
    }
    function thumbEls() {
      var t = (gallery && gallery.querySelectorAll("[data-thumb]")) || [];
      if (!t.length) t = document.querySelectorAll("[data-thumb]");
      return t;
    }
    function activeIdx() {
      var a = (gallery && gallery.querySelector("[data-thumb].is-active")) || document.querySelector("[data-thumb].is-active");
      if (a) { var n = parseInt(a.getAttribute("data-thumb"), 10); if (!isNaN(n)) return n; }
      var tr = rail.style.transform || "";
      var i = tr.indexOf("translateX(");
      if (i !== -1) {
        var rest = tr.slice(i + 11);
        var num = parseFloat(rest);
        if (!isNaN(num)) {
          if (rest.indexOf("%") !== -1 && rest.indexOf("px") === -1) return Math.round(Math.abs(num) / 100);
          var sw0 = slideWidth(); if (sw0) return Math.round(Math.abs(num) / sw0);
        }
      }
      return 0;
    }

    var down = false, moved = false, startX = 0, basePx = 0, sw = 0, idx = 0, pid = null;

    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;              // native swipe handles touch
      if (isMobile()) return;                              // small screens = native scroll
      if (e.button !== undefined && e.button !== 0) return; // left button only
      if (e.target && e.target.closest && e.target.closest("video, iframe, .lvp-gallery__play, .lvp-gallery__video")) return;
      down = true; moved = false;
      idx = activeIdx();
      sw = slideWidth();
      basePx = -idx * sw;
      startX = e.clientX;
      pid = e.pointerId;
      rail.style.transition = "none";                      // 1:1 follow while dragging
      rail.style.cursor = "grabbing";
      rail.style.userSelect = "none";
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
    });

    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      var last = slideCount() - 1;
      if ((idx === 0 && dx > 0) || (idx === last && dx < 0)) dx *= 0.35; // resistance at the ends
      rail.style.transform = "translateX(" + (basePx + dx) + "px)";
    });

    function finish(e) {
      if (!down) return;
      down = false;
      if (pid !== null) { try { rail.releasePointerCapture(pid); } catch (err) {} pid = null; }
      rail.style.cursor = "grab";
      rail.style.userSelect = "";

      var dx = (e && typeof e.clientX === "number") ? e.clientX - startX : 0;
      var threshold = Math.max(40, sw * 0.18);
      var last = slideCount() - 1;
      var target = idx;
      if (dx <= -threshold && idx < last) target = idx + 1;
      else if (dx >= threshold && idx > 0) target = idx - 1;

      rail.style.transition = "";                          // restore CSS transition (0.4s)
      var thumbs = thumbEls();
      if (thumbs && thumbs[target]) {
        thumbs[target].click();                            // hand off to the gallery's own go()
      } else {
        rail.style.transform = "translateX(" + (-target * 100) + "%)";
      }
    }
    rail.addEventListener("pointerup", finish);
    rail.addEventListener("pointercancel", finish);

    // swallow the click that fires right after a real drag
    rail.addEventListener("click", function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-gallery-rail]"), init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();